@if (timesheet.ready$ | async) {
  <div class="mb-2 mt-4 flex w-full items-center justify-start gap-4 px-4">
    <div class="shrink-0">
      <wedate-input [dateHandler]="timesheet.weDate" [hasIncrementors]="true" (weDateChanged)="handleWeDateChanged()" />
    </div>
    @if (isWholeContract) {
      <span class="mr-auto">Viewing all records and timesheets for {{ contractDescription }}</span>
    } @else {
      <span class="mr-auto text-xl/none">
        @if (timesheetTabs[activeTimesheetTabIndex].displayProperty1 !== 'All') {
          <span>{{ timesheetTabs[activeTimesheetTabIndex].displayProperty1 }}: </span>
        }
        <span>{{ timesheetDesc }}</span></span
      >
    }
    <div class="flex shrink-0 items-center justify-end gap-4">
      <span>{{ timesheet.timesheetStatus.description }}</span>
      <span [matTooltip]="timesheet.timesheetStatus.error">
        <button
          mat-raised-button
          color="warn"
          [disabled]="!timesheet.timesheetStatus.shouldPermitBillingApproval"
          (click)="approve()"
        >
          Approve
        </button>
      </span>
    </div>
  </div>
  <div class="flex justify-start gap-4">
    <div class="mt-12 flex h-[50vh] flex-col justify-between border-r border-[lightgray] pr-2">
      <tabs layout="col" [tabs]="sectionTabs" [active]="1" (tabChanged)="setActive($event)" />
      <div class="flex flex-col items-stretch gap-2 pl-2">
        <span class="mat-headline-6 border-b border-[lightgray] text-center">Toolbar</span>
        <button mat-raised-button (click)="handleWholeContractClick()">
          @if (isWholeContract) {
            <mat-icon>zoom_in</mat-icon>
          } @else {
            <mat-icon>zoom_out</mat-icon>
          }
          {{ wholeContractText }}
        </button>
        <button mat-raised-button (click)="addEquipment()">
          <mat-icon>local_shipping</mat-icon>
          Add Equipment +
        </button>
      </div>
    </div>
    <div class="w-[55%] min-w-[600px] flex-col justify-start" [class.w-full]="!isSplitScreen">
      <tabs
        #timesheetTabsEl
        layout="row"
        finalTabWidth="65px"
        [tabs]="timesheetTabs"
        [shouldSeparateFinal]="true"
        [active]="activeTimesheetTabIndex"
        (tabChanged)="handleTimesheetChange($event)"
      />
      <div class="flex flex-col">
        @if (selectedSectionTabName === 'Attachments') {
          <div class="flex h-12 w-full items-center bg-[#388E3C] p-2 text-white">
            <single-file-upload
              class="flex w-full"
              [timesheet]="timesheet"
              [currentSharepointUploadData]="currentSharepointUploadData"
              [isAttachButtonEnabled]="isAttachButtonEnabled"
            />
          </div>
        }
        @for (table of configsAndValues; track table) {
          @if ($index === activeSectionTabIndex) {
            @if (table.shouldShowHeaders) {
              <timesheet-headers class="border-t-8 border-t-[#388e3c]" [timesheets]="currentTimesheets" />
            } @else {
              <table-like-layout
                configPath="__config"
                [shouldHideTotal]="!table.shouldShowTotal"
                [config]="table.config"
                [valuePath]="table.valuePath"
                [appearance]="table.appearance"
                [values]="table.values"
                (valueChanged)="handleValueChange($event, table)"
                (iconClicked)="handleIconClicked($event)"
                (numberBoxClicked)="changeDetailPayne($event)"
                (textClicked)="handleTextClick($event)"
              />
              @if (table.shouldShowProductionText) {
                <table-like-layout
                  valuePath="billingGrid"
                  columnLimit="4"
                  [config]="billingProductionTextConfig"
                  [values]="billingProductionTextValues"
                  [shouldHideTotal]="true"
                  [shouldHideHeaders]="true"
                  (numberBoxClicked)="changeDetailPayne($event)"
                  (textClicked)="handleTextClick($event)"
                />
              }
              @if (table.addFunction) {
                <div class="flex items-center gap-3 pl-3 pt-6">
                  <div class="relative flex flex-wrap">
                    @if (!isViewingSingleTimesheet) {
                      <small class="absolute bottom-12 left-28 w-full text-gray-400">Select a timesheet to add a stop</small>
                    }
                    <div class="flex items-center gap-4">
                      <h3 [class.text-gray-400]="!isViewingSingleTimesheet">Add Stop On:</h3>
                      <mat-button-toggle-group hideSingleSelectionIndicator="true" (change)="handleAddGroupClicked($event)">
                        @for (day of dates; track day) {
                          <mat-button-toggle [value]="day" [disabled]="!isViewingSingleTimesheet || isLoadingProdGroup">
                            <div class="align-items-center flex flex-col leading-snug">
                              <strong class="uppercase">{{ day.weekDay }}</strong>
                              <span>{{ day.display }}</span>
                            </div>
                          </mat-button-toggle>
                        }
                      </mat-button-toggle-group>
                    </div>
                    @if (isLoadingProdGroup) {
                      <mat-spinner class="ml-2 self-center" [diameter]="30" />
                    }
                  </div>
                </div>
              }
            }
          }
        }
      </div>
    </div>
    @if (isSplitScreen) {
      <detail-payne class="w-2/5 min-w-[500px]" />
    }
  </div>
} @else {
  <div class="section-loader-wrapper">
    <mat-spinner />
  </div>
}

<ng-template #text>
  <table-like-layout
    valuePath="billingGrid"
    columnLimit="4"
    [config]="billingProductionTextConfig"
    [values]="billingProductionTextValues"
    [shouldHideTotal]="true"
    [shouldHideHeaders]="true"
    (numberBoxClicked)="changeDetailPayne($event)"
    (textClicked)="handleTextClick($event)"
  />
</ng-template>
